// import { unitCaseEnum } from "../../../../../utils/settings";
const unitCaseEnum = {
  CASE: 1,
  UNIT: 2,
};

const roundToThreeDecimals = (num) => Math.round((num + Number.EPSILON) * 1000) / 1000;

const defaultState = {
  isSellToBuyer: false,
  cartItemList: [],
  unitCaseWise: unitCaseEnum['UNIT'],
  alignmentValue: 1, // Default to Unit (1)
  companyName: '',
  companyDetails: {},
  userIndex: 0,
};

const fmcgReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'RESET_FMCG_REDUCER': {
      return defaultState;
    }
    // Used in Inventory
    case 'CLEAR_CART': {
      return { ...state, cartItemList: [] };
    }
    case 'UPDATE_PROD_QTY': {
      let { type, data, inputValue } = action.data;

      if (typeof inputValue === 'number' && inputValue === 0) type = 'REMOVE';

      let totalQty = 0;
      if (state.unitCaseWise === unitCaseEnum['UNIT'])
        totalQty = data.allocable_quantity.quantity_in_bags;
      else totalQty = data.allocable_quantity.quantity_in_metric_ton;

      let oldCartList = state?.cartItemList || [];

      let productAdded =
        oldCartList.find(
          (item) =>
            item.product_info.product_id === data.product_info.product_id,
        ) || {};

      const index = oldCartList.findIndex(
        (item) => item.product_info.product_id === data.product_info.product_id,
      );

      if (type === 'ADD') {
        if (Object.keys(productAdded).length > 0) {
          if (
            productAdded.sellToBuyerQty.qty + 1 > totalQty ||
            inputValue > totalQty
          )
            return state;

          productAdded.sellToBuyerQty = {
            ...productAdded.sellToBuyerQty,
            qty:
              typeof inputValue === 'number'
                ? inputValue
                : productAdded.sellToBuyerQty.qty + 1,
          };

          oldCartList.splice(index, 1, productAdded);

          return {
            ...state,
            cartItemList: oldCartList,
          };
        } else {
          if (totalQty < 1 || totalQty < inputValue || inputValue === 0)
            return state;

          oldCartList = [
            ...oldCartList,
            {
              ...data,
              sellToBuyerQty: {
                qty: inputValue ? inputValue : 1,
              },
            },
          ];

          return {
            ...state,
            cartItemList: oldCartList,
          };
        }
      } else if (type === 'REMOVE') {
        if (
          Object.keys(productAdded).length === 0 ||
          productAdded?.sellToBuyerQty?.qty === 0
        )
          return state;

        productAdded.sellToBuyerQty = {
          ...productAdded.sellToBuyerQty,
          qty:
              typeof inputValue === 'number'
                ? inputValue
                : Math.max(0, roundToThreeDecimals(productAdded.sellToBuyerQty.qty - 1)),
        };

        if (productAdded.sellToBuyerQty.qty <= 0 || inputValue === 0) {
          oldCartList.splice(index, 1);
        } else {
          oldCartList.splice(index, 1, productAdded);
        }

        return {
          ...state,
          cartItemList: oldCartList,
        };
      } else {
        oldCartList = oldCartList.filter(
          (item) =>
            item.product_info.product_id !== data.product_info.product_id,
        );

        return {
          ...state,
          cartItemList: oldCartList,
        };
      }
    }
    case 'FMCG_UNIT_CASE_WISE': {
      return {
        ...state,
        unitCaseWise: action.data,
      };
    }
    case 'SET_ALIGNMENT_VALUE': {
      return {
        ...state,
        alignmentValue: action.data,
      };
    }
    default:
      return state;
  }
};

export default fmcgReducer;
